import React from "react";
import { Toaster } from "react-hot-toast";
import "./AuthLayout.css";

/**
 * The split screen shared by signing in, resetting a forgotten password, and
 * choosing a password for the first time.
 *
 * The form on the left, what the system is on the right. Sharing one shell
 * across the three means they read as one product, and a change to any of it
 * lands on all three at once.
 *
 * Props:
 *   title / subtitle   the heading above the form
 *   children           the form itself
 *   footer             the line under it — links, usually
 *   panel              { headline, blurb } for the brand side
 */

/** Both live with the logo, in template/assets/images. */
const IMAGES = `${process.env.PUBLIC_URL || ""}/template/assets/images`;

/** The photograph the sign-in page has always carried, kept as the ground all
 *  three of these pages stand on. */
const BACKDROP = `${IMAGES}/project_login.png`;

/** The dashboard: the four figures across the top, stock movement in and out by
 *  month, and projects by priority. Vector rather than a screenshot, so it stays
 *  sharp on any display and weighs a few kilobytes on the page everyone loads. */
const DASHBOARD = `${IMAGES}/dashboard-preview.png`;

export default function AuthLayout({
  title,
  subtitle,
  children,
  footer,
  panel,
}) {
  return (
    <div className="auth-screen" style={{ "--auth-bg": `url("${BACKDROP}")` }}>
      <Toaster position="top-center" />

      <div className="auth-card">
        <div className="auth-form-side">
          <div className="auth-brandmark">
            <img
              src={`${process.env.PUBLIC_URL}/template/assets/images/bericot_logo.png`}
              alt="Bericot"
            />
          </div>

          <div className="auth-form-inner">
            <h1 className="auth-title">{title}</h1>
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
            {children}
            {footer && <p className="auth-foot">{footer}</p>}
          </div>

          <div className="auth-legal">
            <span>
              &copy; {new Date().getFullYear()} Bericot Africa Limited
            </span>
            <span>All rights reserved</span>
          </div>
        </div>

        <div className="auth-brand-side">
          {/* The whole system, not the half of it you happen to be signing in
              for. Accounting is one part of Bericot — saying only that on the
              way in makes the rest of it invisible. Kept the same on all three
              pages: what the system is does not change with the errand. */}
          <h2 className="auth-headline">
            {panel?.headline || "Everything Bericot runs, in one place"}
          </h2>
          <p className="auth-blurb">
            {panel?.blurb ||
              "Projects, teams and installations. Stores, stock and deliveries. Staff, payroll and a full set of books."}
          </p>
          <img
            className="auth-shot"
            src={DASHBOARD}
            alt=""
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  );
}
